var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSatellitePoorNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.404 18C3.81 17.94.077 14.098 0 9.354h1.373c.075 3.96 3.181 7.155 7.03 7.233V18z",
    fill: "#6D7278"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.404 12.982c-1.905-.077-3.432-1.648-3.507-3.607l1.353-.02c.059 1.198.99 2.155 2.154 2.215v1.412z",
    fill: "#F7B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.115 0a.741.741 0 0 0-.535.228l-.946.974a.789.789 0 0 0 0 1.1l2.55 2.622 2.014-2.074L8.65.228A.743.743 0 0 0 8.115 0zM13.883 2.073a.99.99 0 0 0-.713.304l-2.936 3.02a1.056 1.056 0 0 0-.026 1.431 1.729 1.729 0 0 0-1.78.443l2.504 2.576c.464-.48.63-1.186.43-1.831a.985.985 0 0 0 1.391-.029l2.936-3.019a1.057 1.057 0 0 0 0-1.466l-1.094-1.125a.99.99 0 0 0-.712-.304zM15.23 6.997l-2.016 2.072 2.55 2.623a.745.745 0 0 0 .534.228c.2 0 .393-.082.534-.228l.947-.973a.789.789 0 0 0 0-1.1l-2.55-2.622zM8.404 15.49c-3.259-.059-5.888-2.764-5.965-6.135h1.373c.056 2.568 2.076 4.646 4.592 4.724v1.411z",
    fill: "#6D7278"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.404 12.982c-1.905-.077-3.432-1.648-3.507-3.607l1.353-.02c.059 1.198.99 2.155 2.154 2.215v1.412z",
    fill: "#DB6969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.556 8.93c.15-.16.356-.25.571-.25.216 0 .422.09.572.25a.829.829 0 0 1 .243.588.829.829 0 0 1-.243.588.784.784 0 0 1-.572.25.784.784 0 0 1-.571-.25.829.829 0 0 1-.243-.588c0-.222.087-.435.243-.589z",
    fill: "#6D7278"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatellitePoorNew);
export default __webpack_public_path__ + "static/media/satellite_poor_new.7f1ae7fc769597232b95e5de4390e368.svg";
export { ForwardRef as ReactComponent };